import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import React, {useState} from "react";
import {CardBody, Col, Form, Row} from "reactstrap";
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import ActionsAndJobs from "./ActionsAndJobs";


const JobHistoryFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter } = componentState?.data || {};

    const [action, setAction] = useState(filter?.item?.action != null ? filter?.item?.action : null)
    const [job, setJob] = useState(filter?.item?.job != null ? filter?.item?.job : null)

    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataFilter = {
            item:{
                action: action?.id,
                job:job?.id
            }
        };

        props.setFilter(path, dataFilter)
    };

    const cleanFields = () => {
        setAction(null);
        setJob(null);
        reset()
    }

    const assignValue = (value, type) => type === 'action' ? setAction(value) : setJob(value)

    return <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody>
                <ActionsAndJobs
                    action={action}
                    job={job}
                    assignValue={assignValue}
                />

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(JobHistoryFilters)